import { render, staticRenderFns } from "./rulesOfUse.vue?vue&type=template&id=dbc2a162&scoped=true"
import script from "./rulesOfUse.vue?vue&type=script&lang=js"
export * from "./rulesOfUse.vue?vue&type=script&lang=js"
import style0 from "./rulesOfUse.vue?vue&type=style&index=0&id=dbc2a162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc2a162",
  null
  
)

export default component.exports